import { typographyTokens } from '../../theme/typographyTokens';
import React, { useRef, useContext } from 'react';
import { Box, TextField, Stack, InputLabel, useTheme } from '@mui/material';
import { TaskContext } from './CreateTask';
import RichTextEditor from '../RichTextEditor/RichTextEditor';
import { useGetTasksWithSEPIDQuery } from '../../../frontend/services/tasksSlice/tasksSlice';
import { showSnackbar } from '../../../frontend/utils/snackbar';
import { useDispatch } from 'react-redux/es/hooks/useDispatch';

const FirstStep = ({ sepID, setIsShortNameValid }: { sepID: number, setIsShortNameValid:React.Dispatch<React.SetStateAction<boolean>> }) => {
  const { task, setTask } = useContext(TaskContext);
  const { data: sepTasks } = useGetTasksWithSEPIDQuery(sepID);
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === 'dark';
  const ref = useRef(null);
  const textFieldSx = {
    color: isDarkMode ? theme.palette.content.white : theme.palette.content.default,
    '& > p': {
      margin: '5px 0px',
      color: isDarkMode ? '#a0a0a0' : theme.palette.prime.granite,
      fontSize: typographyTokens.fontSizes.xs,
    },
  };
 
  const timeoutRef = useRef<number | undefined>(undefined);
  const dispatch = useDispatch();  

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setTask(() => ({ ...task, shortName: value }));

    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    timeoutRef.current = window.setTimeout(() => {
      if (!value) {
        setIsShortNameValid(true);
        return;
      }

      const shortNames = sepTasks?.map(task => task.shortName.toLowerCase()) || [];
      const taskShortName = value.toLowerCase();
      const isDuplicate = shortNames.includes(taskShortName);

      setIsShortNameValid(!isDuplicate);

      if (isDuplicate) {
        showSnackbar(
          dispatch,
          { errorMessage: `The task name '${value}' is already in use. Please choose a different name.` },
          'error',
          7000
        );
      }

    }, 500);
  };

  return (
    <Stack
      display="flex"
      direction="column"
      alignItems="left"
      spacing={4}
      sx={{ p: 4 }}
    >
      <Box>
        <InputLabel sx={{ color: isDarkMode ? theme.palette.content.white : theme.palette.content.default }} htmlFor="task-name">
          Task Name
        </InputLabel>
        <TextField
          sx={textFieldSx}
          size="small"
          id="task-name"
          fullWidth
          value={task.name || ''}
          placeholder="Ex. Please have vendor complete the Cloud Security Requirements Mat…"
          helperText="This should be the actual task name that will display on an SEPs Task List"
          onChange={(e) => {
            setTask({ ...task, name: e.target.value });
          }}
        />
      </Box>
      <Box>
        <InputLabel
          sx={{ color: isDarkMode ? theme.palette.content.white : theme.palette.content.default }}
          ref={ref}
          htmlFor="task-assignment-name"
        >
          Task Assignment Name
        </InputLabel>
        <TextField
          sx={textFieldSx}
          size="small"
          id="task-shortName"
          fullWidth
          value={task.shortName || ''}
          placeholder="Ex. Please have vendor complete the Cloud Security Requirements Mat…"
          helperText="This name appears in the Task Assigner options on the Review tab of an SEP’s Overview"          
          onChange={handleChange}
        />
      </Box>
      <Box>
        <InputLabel htmlFor="task-description" sx={{ color: isDarkMode ? theme.palette.content.white : theme.palette.content.default }}>
          Task Description
        </InputLabel>
        <RichTextEditor
          style={{ height: '40vh', color: isDarkMode ? theme.palette.content.white : theme.palette.content.black }}
          value={task.description ?? ''}
          setValue={(val) => setTask({ ...task, description: val })}
        />
        {/* <TextField 
          size="small"
          id="task-description"
          fullWidth
          placeholder="Ex. We need to understand the scope to determine which teams will need to review this request. Please select all that apply."
          multiline
          rows={4}
          value={task.description || ''}
          onChange={(e) => {
            setTask({ ...task, description: e.target.value });
          }}
        /> */}
      </Box>
    </Stack>
  );
};

export default FirstStep;
